import { images } from "assets/themes";
import React from "react";

const OfflineView = () => {
  return (
    <div className="d-flex flex-column h-100">
        <div className="position-fixed top-0 start-0 m-md-3 m-2">
            <img src={images.logo} alt="Bahi Khata" style={{width: "40px", height: "40px"}} />
        </div>
      <div className="d-flex flex-column m-auto">
        <i
          className="bi bi-router text-app mx-auto"
          style={{ fontSize: "7rem" }}
        ></i>
        <span className="mx-auto h3">You appear to be Offline</span>
        <span className="mx-auto">You need to have an active Internet connection to use this App.</span>
      </div>
    </div>
  );
};

export default OfflineView;
